export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/local_photography.16d9c6f.svg";